import { Styles } from '@/styles';

export const styles: Styles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',

  '.mobile-app-button': {
    transition: 'opacity .2s',

    '&:hover, &:focus': {
      opacity: 0.7,
    },
  },
};
